<template>
    <article class="card-subscribe" ref="$card">
        <div class="card-subscribe__bg" ref="$bg">
            <UiImage v-if="!!data?.media.length" :src="data?.media[0].webp" :classes="'responsive f-height'" />
        </div>
        <div class="card-subscribe__title h4" v-html="nl2br(data.headline)" ref="$title"></div>
        <div class="card-subscribe__form">
            <FormsSubscribe />
            <div class="form-description" ref="$description">Get notified when we launch</div>
        </div>
    </article>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: {}
        },
        isAnimated: {
            type: Boolean,
            default: false
        }
    });

    const { $gsap: gsap } = useNuxtApp();
    const $card = ref(null);
    const $bg = ref(null);
    const $title = ref(null);
    const $description = ref(null);

    useStartAnimations(() => {
        if (props.isAnimated) {
            gsap.set($bg.value, {
                scale: 1.3,
                yPercent: 15
            });

            gsap.set($title.value, {
                opacity: 0,
                filter: "blur(5px)",
                scale: 0.95
            });

            gsap.set($description.value, {
                opacity: 0,
                filter: "blur(5px)",
                scale: 0.95
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: $card.value,
                    start: "top 40%"
                }
            })
                .addLabel("cardAnimaton")
                .to(
                    $bg.value,
                    {
                        scale: 1,
                        yPercent: 0,
                        ease: "power1",
                        duration: 0.6
                    },
                    "cardAnimaton"
                )
                .to(
                    $title.value,
                    {
                        opacity: 1,
                        filter: "blur(0)",
                        scale: 1,
                        ease: "power1",
                        duration: 0.3
                    },
                    "cardAnimaton+=0.1"
                )
                .to(
                    $description.value,
                    {
                        opacity: 1,
                        filter: "blur(0)",
                        scale: 1,
                        ease: "power1",
                        duration: 0.3
                    },
                    "cardAnimaton+=0.1"
                );
        }
    });
</script>
